// 营业执照相关API

// 上传营业执照
export function uploadLicense(filObj) {
    let params = new FormData();
    params.append("license", filObj);
    return{
        url: '/license_trans/business',
        method: 'post',
        data: params
    }
}


// 修改信息
export function editInfo(data) {
    if(typeof data.valid_period == "object"){
        data.valid_period =data.valid_period[0]+' 至 '+data.valid_period[1]
    }
    return{
        url: '/license_trans/sure_business',
        method: 'post',
        data: data
    }
}


// 下载文件
export function downloadImg(id, type, side='') {
    return{
        url: `/license_trans/download/${id}?file_type=${type}&side=${side}`,
        method: 'get',
        responseType: 'blob'
    }
}


// 根据ID获取预览地址
export function getPreviewImg(id, type, side='') {
    return{
        url: `/license_trans/preview/${id}?file_type=${type}&side=${side}`,
        method: 'get',
    }
}
